import { memo, useContext } from 'react'
import { TtsItemSpeakerFlyoutContent } from './Content'
import { TTS_SPEAKER_ITEM_CLASS_NAME } from '../consts'
import { TTS_LANGUAGE_ITEM_CLASS_NAME } from '../consts'
import { useTtsItemSpeakerFlyout } from './useTtsItemSpeakerFlyout'
import { TtsItemSpeakerFlyoutContext } from './contextApi'
import { TtsItemContext } from '../contextApi'
import TtsFlyout from 'containers/SubSidebar/TtsContent/components/TtsFlyout'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

interface IProps {
  isOpen: boolean
  node: HTMLElement | null
  closeDropdown: () => void
}

const TtsItemSpeakerFlyout: React.FC<IProps> = ({
  isOpen,
  node,
  closeDropdown
}: IProps) => {
  const {
    ttsItemLangCode,
    ttsActiveSpeakerId,
    ttsItemInstruction,
    hasEmotion,
    isAnyChanges,
    handleLanguageChange,
    handleVoiceChange,
    handleToneChange,
    handleConfirmButton
  } = useTtsItemSpeakerFlyout(closeDropdown)

  const { scrollableParentRef } = useContext(TtsItemContext)

  return (
    <TtsItemSpeakerFlyoutContext.Provider
      value={{
        ttsItemLangCode,
        ttsActiveSpeakerId,
        ttsItemInstruction,
        handleLanguageChange,
        handleVoiceChange,
        handleToneChange,
        hasEmotion,
        isAnyChanges,
        handleConfirmButton
      }}
    >
      <TtsFlyout
        isOpen={isOpen}
        width={320}
        height={hasEmotion ? 465 : 265}
        togglerElement={node}
        onClose={closeDropdown}
        hasAlertTooltip={isAnyChanges}
        scrollableContainerRef={scrollableParentRef}
        alertTooltipText={translate(T.SAVE_CHANGES_ALERT_TOOLTIP)}
        buttonsConfig={{
          confirmButton: {
            title: translate(T.SAVE),
            onClick: handleConfirmButton,
            disabled: !isAnyChanges
          },
          cancelButton: {
            title: translate(T.CANCEL),
            onClick: closeDropdown
          }
        }}
        ignoredClassNames={[
          TTS_SPEAKER_ITEM_CLASS_NAME,
          TTS_LANGUAGE_ITEM_CLASS_NAME
        ]}
      >
        <TtsItemSpeakerFlyoutContent />
      </TtsFlyout>
    </TtsItemSpeakerFlyoutContext.Provider>
  )
}

export default memo(TtsItemSpeakerFlyout)
